import { createInterfaceSound, playInterfaceSound } from '@/service/interfaceSound';

const switchClickSound = createInterfaceSound('/sound/click.wav');

const playSwitchClickSound = () => {
    switchClickSound.currentTime = 0;
    playInterfaceSound(switchClickSound).catch(() => undefined);
};

const isDisabledSwitch = (element: Element) => (
    element.classList.contains('v-input--is-disabled') ||
    element.getAttribute('aria-disabled') === 'true'
);

const onSwitchInteraction = (target: EventTarget | null) => {
    if (!(target instanceof Element)) {
        return;
    }

    const switchElement = target.closest('.v-input--switch');
    if (!switchElement || isDisabledSwitch(switchElement)) {
        return;
    }

    playSwitchClickSound();
};

document.addEventListener('click', event => {
    onSwitchInteraction(event.target);
}, true);

document.addEventListener('keydown', event => {
    if (event.key !== ' ' && event.key !== 'Enter') {
        return;
    }

    onSwitchInteraction(event.target);
}, true);
